module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notice":"To load this element, it is required to consent to the following cookie category: {type}."},"fi":{"notice":"Tämän sisällön näyttäminen edellyttää seuraavan evästetyypin hyväksymistä: {type}."},"sv":{"notice":"För att visa det här elementet, krävs att du samtycker till följande cookie-kategori: {type}."}}')
  delete Component.options._Ctor
}
